import { Button, Card, CardActionArea, CardContent, LinearProgress, Link, Typography, makeStyles } from '@material-ui/core';
import moment from "moment-timezone";
import { PageHeader } from 'pages/CustomerBookingCreate/components/PageHeader';
import { START_STEP, STEP_BOOKING_LIST, STEP_RECIPIENT } from 'pages/CustomerBookingCreate/constants';
import { useCallback, useEffect, useRef, useState } from 'react';
import ReactJson from 'react-json-view';
import { Virtuoso } from 'react-virtuoso';
import { isAuthenticated, useUserState } from 'services/authentication.service';
import { listBookings } from 'services/booking.service';
import { BookingListItem } from './BookingListItem';
import { VirtuosoMUIComponents } from 'pages/CustomerBookingCreate/VirtuosoComponents';
import { useTrackEvent } from 'util/trackEvent';

import { Add } from '@material-ui/icons';
import { useRecoilState } from 'recoil';
import { stepState } from 'pages/CustomerBookingCreate/state';
import { Redirect, useHistory } from 'react-router-dom';


const useStyles = makeStyles(theme => ({
  list: {

    minHeight: '60vh'
  }
}));



const BookingList = ({ }) => {
  const classes = useStyles()
  const [loading, setLoading] = useState(false);
  const trackEvent = useTrackEvent()

  const [params, setParams] = useState({
    page_size: 20,
    page_offset: 0,
  });

  const [count, setCount] = useState(0);
  const [bookings, setBookings] = useState([]);
  const { getUser } = useUserState()

  const [step, setStep]= useRecoilState(stepState);
  const virtuoso = useRef(null)
  const history = useHistory()
  const fetchBookings = useCallback(
    async () => {
      try {
        setLoading(true)
        const client = (await getUser())
        const clientId = client?.client?.id || client?.user?.id
        const res = await listBookings(clientId, params);
        setBookings([
          ...bookings,
          ...(res?.list || [])?.map((item) => {
            return {
              ...item,
            }
          }
          )])
        setCount(res?.count || 0)
        setLoading(false)
      } catch (error) {
        trackEvent('Booking list error', { error: error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details })
        setLoading(false)
      }
    },
    [params],
  );

  useEffect(() => {
    fetchBookings()
  }, [])

  const onClick = useCallback(
    (item) => {
      console.log('item', item)
    },
    [],
  );

  const [endItem, setEndItem] = useState(null);
  return (
    <>
      <PageHeader
        title="My Bookings"
        subheader='List of your current bookings and your booking history.'
        backStep={START_STEP}
        currentStep={STEP_BOOKING_LIST}
        showBreadcrumbs={false}
        actions={()=><Button
          variant="contained"
          color="primary"
          startIcon={<Add />}
          onClick={() => {
            setStep(START_STEP)
            history.replace(START_STEP, { internal: true })
          }}>New Booking</Button>}
      >
        <Virtuoso
          className={classes.list}
          context={{ onClick }}
          data={bookings}
          totalCount={count}
          endReached={(item) => {
            const page = item + 1
            setParams({
              ...params,
              page_offset: page
            })
            setEndItem(item)
          }}
          atBottomStateChange={(atBottom) => {
            if (atBottom && endItem && bookings?.length < count) {
              fetchBookings()
            }
          }}
          overscan={100}
          itemContent={(index, booking, context) => {
            return (
              <BookingListItem
                key={index}
                booking={booking}

              />
            )
          }}
        />


      </PageHeader>
    </>
  )
}

const WrappedListBookingScreen = (props) => {
  if (isAuthenticated()) {
    return <BookingList {...props} />
  }
  return <Redirect to={START_STEP} />
}

export { WrappedListBookingScreen as BookingList };
